(function($){
	$(document).ready(function(){

		document.addEventListener('basket:update', ()=>{
			// Limit input symbols
			$('.js-counter-limit').each((index, item) => {
				$(item).unbind('input');
				$(item).unbind('change');

				$(item).on('input change', ({target})=> {
					const clearPriceString = (target.value).replace(/\D/gm, '');
					target.value = clearPriceString;
					if (clearPriceString.length >= 3) target.value = clearPriceString.slice(0,3);
				});
			});
		});

		document.addEventListener('basket:update', ()=>{
			// Increase/Decrease handlers
			$('.js-counter').each((index, item)=> {
				const $plus = $(item).find('.counter__plus');
				const $minus = $(item).find('.counter__minus');
				const $input = $(item).find('.counter__input');
				const id = $(item).find('.counter__id').val();

				$plus.unbind('click');
				$minus.unbind('click');

				$plus.on('click', (e)=>{
					e.preventDefault();
					let val = Number($input.val());

					if (val > 999) return;
					$input.val(val++);

					if (!window.products_in_basket) return;
					if (!window.products_in_basket[id]) return;

					window.products_in_basket[id] = val;

					// eslint-disable-next-line no-undef
					dataLayer && dataLayer.push({
						'ecommerce': {
							'currencyCode': 'RUB',
							'add': {
								'products': [{ id }]
							}
						},
						'event': 'addToCart',
						'EE-event-category': 'ecommerce',
						'EE-event-action': 'add',
						'EE-event-non-interaction': 'False'
					});

					__updateBasket(window.products_in_basket[id], id);
				});

				$minus.on('click', (e)=> {
					e.preventDefault();
					let val = Number($input.val());

					if (val < 1) return;
					$input.val(val--);

					if (!window.products_in_basket) return;
					if (!window.products_in_basket[id]) return;

					window.products_in_basket[id] = val;

					// eslint-disable-next-line no-undef
					dataLayer && dataLayer.push({
						'ecommerce': {
							'currencyCode': 'RUB',
							'add': {
								'products': [{ id }]
							}
						},
						'event': 'removeFromCart',
						'EE-event-category': 'ecommerce',
						'EE-event-action': 'add',
						'EE-event-non-interaction': 'False'
					});

					__updateBasket(window.products_in_basket[id], id);
				});
			});
		});

		function __updateBasket(val, id) {
			// eslint-disable-next-line no-undef
			BX.ajax({
				url: '/local/ajax/basket.php',
				data: {
					'QUANTITY': val,
					'productId': id
				},
				method: 'POST',
				dataType: 'json',
				timeout: 30,
				async: true,
				processData: true,
				scriptsRunFirst: true,
				emulateOnload: true,
				start: true,
				cache: false,
				onsuccess: function (data) {
					data += '<button type="button" class="mfp-close modal__close"><i class="icon-close"></i></button>';
					$('#basket').html(data);

					const basket = window.rw ? window.rw.basket : [];
					!basket.length && $.magnificPopup.close();

					window.initBasketPopupSlider();
				},
				onfailure: function () {}
			});
			if (!!window.rw.basketObjects.topPc) {
				window.rw.basketObjects.topPc.refreshCart({});
			}
			if (!!window.rw.basketObjects.topPc) {
				window.rw.basketObjects.topMobile.refreshCart({});
			}
		}

	});
// eslint-disable-next-line no-undef
})(jQuery);
